<section class="footer-social">
  <div class="footer-social__item">
    <ul class="footer-apps">
      @for (item of items.apps; track item) {
        <li class="footer-apps__item footer-app">
          <a
            [attr.href]="item?.disabled ? null : item?.link"
            target="_blank"
            rel="noopener"
            class="footer-app__link eye-hover"
            [class.disabled]="item?.disabled"
            [title]="item?.text | translate"
            [attr.aria-label]="item?.text | translate"
          >
            <div
              [inlineSVG]="'../assets/img/apps/' + item?.type + '.svg'"
              [attr.aria-label]="item?.type"
            ></div>
          </a>
        </li>
      }
    </ul>
  </div>
  <div class="footer-social__item footer-social__item--buttons">
    <ul class="footer-buttons pl-sm-2">
      @for (item of items.buttons; track item) {
        <li class="footer-buttons__item footer-button">
          <a
            [href]="item?.link"
            target="_blank"
            rel="noopener"
            class="footer-button__link eye-hover"
            [title]="item?.text | translate"
            [attr.aria-label]="item?.text | translate"
          >
            <div class="footer-button__icon">
              <fa-icon [icon]="iconMap.get(item?.type)" size="lg"></fa-icon>
            </div>
          </a>
        </li>
      }
    </ul>
  </div>
</section>
